// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-X":"X_dpu-detail-X__UfY1Y"};